import type { ReactElement } from 'react';

import dynamic from 'next/dynamic';

import type { AiWatermarkProps } from '~/components/shared/aiWatermark/AiWatermarkBase';
import { FeatureFlag } from '~/components/shared/FeatureFlag';

const AiWatermarkBase = dynamic(
  async () => (await import('~/components/shared/aiWatermark/AiWatermarkBase')).AiWatermarkBase,
  { ssr: false }
);

export const AiWatermark = (props: AiWatermarkProps): ReactElement => (
  <FeatureFlag flag="aiImagesWatermarkEnabled">
    <AiWatermarkBase {...props} />
  </FeatureFlag>
);
